<template>
  <div>
    <button @click="makePostRequest">Make POST Request</button>
    <button @click="makeGetRequest">Make GET Request</button>

    <div v-if="getResponse">
      <h3>GET Response:</h3>
      <pre>{{ getResponse }}</pre>
    </div>
  </div>
</template>

<script>
import apiClient from '../apiClient';

export default {
  name: 'Test',
  data() {
    return {
      data: {},
      getResponse: null,
    };
  },
  methods: {
    makePostRequest() {
      const payload = {
        key: 'customKey',
        value: 'customValue',
      };

      apiClient.post('/dev/set', payload)
          .then((response) => {
            console.log('POST request successful:', response.data);
          })
          .catch((error) => {
            console.error('Error with POST request:', error);
          });
    },
    makeGetRequest() {
      apiClient.get('/dev/get')
          .then((response) => {
            this.getResponse = response.data;
            console.log('GET request successful:', response.data);
          })
          .catch((error) => {
            console.error('Error with GET request:', error);
          });
    },
  },
};
</script>

<style scoped>
button {
  margin: 10px;
  padding: 10px 20px;
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}
button:hover {
  background-color: #0056b3;
}
</style>